<style scoped lang="scss" type="text/scss">
    .sub-confirm-container {
        .tips {
            .info-panel:not(:first-of-type) {
                margin-top: 1rem;
            }
        }

        .tip-text {
            margin-bottom: 1rem
        }
    }
</style>

<template>
    <div class="sub-confirm-container">
        <block-divider>注意事项</block-divider>
        <div class="tips">
            <info-panel class="info-panel">必须完成全部必选的填报项，才能进行最终确认</info-panel>
            <info-panel class="info-panel">确认填报后，将无法继续修改本届参赛信息</info-panel>
            <info-panel class="info-panel">到达填报截止时间时，未手动进行最终确认的队伍会自动完成确认</info-panel>
            <info-panel class="info-panel">到达填报截止时间却未完成全部必填项的参赛队，可能会在赛事奖励等事宜中受到影响</info-panel>
            <info-panel class="info-panel">最终确认后，系统会将本届填报信息通过邮件发送至领队指导教师、学生队长，并抄送组委会，以作为证书等奖项凭证</info-panel>
            <info-panel class="info-panel">请确认领队指导教师、学生队长已完善个人邮箱信息</info-panel>
            <info-panel class="info-panel">最终确认只能进行一次，但之后您可以选择再次发送邮件，以避免偶发的邮件无法正常送达的情况</info-panel>
        </div>

        <block-divider>最终确认</block-divider>
        <info-panel class="tip-text" type="warning" v-if="!confirmable">{{ tipText }}</info-panel>
        <el-button :loading="confirmRequesting" type="primary" size="large" plain :disabled="!confirmable"
                   @click="confirm">
            最终确认
        </el-button>
        <el-button :loading="sendConfirmationEmailRequesting" type="primary" size="large" plain v-if="confirmed"
                   @click="sendConfirmationEmail">
            重新发送邮件
        </el-button>
    </div>
</template>

<script>
    import BlockDivider from '../../../../../components/divider/block';
    import InfoPanel from '../../../../../components/info-panel/index';
    import {mapState} from 'vuex';

    export default {
        name: '',
        components: {
            BlockDivider,
            InfoPanel
        },
        data () {
            return {
                confirmRequesting: false,
                sendConfirmationEmailRequesting: false
            };
        },
        computed: {
            ...mapState('player', {
                currentManagedPlayerId: state => state.currentManagedPlayerId,
                currentManagedPlayerInfo: state => state.currentManagedPlayerInfo
            }),
            fillingComplete () {
                return this.$store.getters['player/fillingComplete'];
            },
            confirmed () {
                return this.$store.getters['player/confirmed'];
            },
            confirmable () {
                const fillingComplete = this.fillingComplete;
                return fillingComplete && !this.confirmed;
            },
            tipText () {
                const fillingComplete = this.fillingComplete;
                const confirmed = this.confirmed;
                let tipText = '最终确认';
                if (!fillingComplete) {
                    tipText = '尚未完成全部必填项';
                } else if (confirmed) {
                    tipText = '已完成最终确认，无法重复操作。如未收到邮件，您可选择重新发送确认邮件';
                }
                return tipText;
            }
        },
        methods: {
            confirm () {
                if (!this.confirmable) {
                    this.$tip(this.tipText);
                    return;
                }
                this.$normalConfirm('最终确认？', '该操作无法撤回，请谨慎操作').then(_ => {
                    this.$normalRequest('player/confirm', {
                        id: this.currentManagedPlayerId
                    }, '最终确认成功，邮件已发送至领队指导教师及学生队长邮箱，请查收', true, this, 'confirmRequesting').then(_ => {
                        this.$store.dispatch('player/loadRegistrableManagedPlayerInfo', {
                            id: this.currentManagedPlayerId
                        }).then();
                    }).catch(_ => {
                    });
                }).catch(_ => {
                });
            },
            sendConfirmationEmail () {
                this.$normalRequest('player/sendConfirmationEmail', {
                    id: this.currentManagedPlayerId
                }, '邮件已发送至领队指导教师及学生队长邮箱，请查收', true, this, 'sendConfirmationEmailRequesting').then(_ => {
                }).catch(_ => {
                });
            }
        }
    };
</script>
